// ============================================================================
// FSA MCA FILING ENDPOINTS (ADR-0027)
// ============================================================================

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaMcaFiling';

export const fsaMcaFilingEndpoints = {
  /** GET /api/v1/FsaMcaFiling/by-engagement/{engId}/{formCode} — pre-download + fill sheets */
  sheet: (engId: ID, formCode: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:formCode`, { engId, formCode }),

  /** PUT /api/v1/FsaMcaFiling/by-engagement/{engId}/{formCode}/values — typed answers / overrides */
  values: (engId: ID, formCode: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:formCode/values`, { engId, formCode }),

  /** POST /api/v1/FsaMcaFiling/by-engagement/{engId}/{formCode}/fill — multipart files → filled ZIP */
  fill: (engId: ID, formCode: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:formCode/fill`, { engId, formCode }),
} as const;

export default fsaMcaFilingEndpoints;
